import { Card, SkeletonBodyText } from "@medentic/polaris-react";
import { Patient } from "../../types";

interface TasksTabContentProps {
  patient?: Patient;
  loading?: boolean;
}

function TasksTabContent({ patient, loading }: TasksTabContentProps) {
  if (loading) {
    return (
      <Card>
        <SkeletonBodyText lines={10} />
      </Card>
    );
  }

  return <Card>{patient?.core_tasks}</Card>;
}

export default TasksTabContent;
